import type { IToggle } from 'unleash-proxy-client';

import type { AppState } from 'types/app';
import { FEATURE_MAFIA_AKAMAI, FEATURE_MARTY_CLIENT_RENDER } from 'constants/features';

export const selectUnleashToggle = (feature: string, state: AppState): IToggle | undefined =>
  (state.unleash?.toggles || []).find((t: IToggle) => t.name === feature);

export const selectABTestEnabled = (testName: string, state: AppState, treatmentValue = '1') =>
  selectUnleashVariant(testName, state) === treatmentValue;

export const selectIsFeatureMafiaAkamai = (state: AppState) => Boolean(selectUnleashToggle(FEATURE_MAFIA_AKAMAI, state)?.enabled);

export const selectIsFeatureMartyClientRender = (state: AppState) => Boolean(selectUnleashToggle(FEATURE_MARTY_CLIENT_RENDER, state)?.enabled);

export const selectUnleashVariant = (feature: string, state: AppState) => selectUnleashToggle(feature, state)?.variant.payload?.value;
